import React from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { base_url } from "../../../helpers/system.helper";

export const BreadCrumbFile = (props) => {
    const home = { icon: "pi pi-cloud-download", url: `${base_url()}/qualityManagement` };

    return <BreadCrumb model={props.items} home={home} />;
};
